<div class="modal-content m-0">
  @if (showCancelButton()) {
    <div class="modal-header">
      <i
        class="fa-light fa-xmark ms-auto cursor-pointer"
        (click)="cancel()"
      ></i>
    </div>
  }
  <div class="modal-body text-center">
    <div class="pt-4 mb-1 loading"></div>
    <small class="text-muted pdf-loading-text" translate>
      {{ options.message | translate }}
    </small>
  </div>
</div>
